import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError, RecoveryAuditTransactionHistoryResponse } from "@/types";

export const useRecoveryAuditTransactionHistory = (transactionId?: number) => {
  return useQuery<RecoveryAuditTransactionHistoryResponse, AppError>({
    queryKey: ["recovery-audit-transaction", transactionId],
    queryFn: async () => {
      return fetchApi(`${API_URL}/reports/recovery/transactions/${transactionId}`);
    },
    enabled: !!transactionId,
  });
};
